var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("\n  Have you discussed injuries with the client and have we recommended the\n  client to a nominated law firm if the client is injured?\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }